import { graphqlRequest } from 'lib/helpers'
import rotateOverlayTokensMutation from 'graphql/rotateOverlayTokens.graphql'

export const RESET_STREAM_KEY_CONFIRM =
  'This turns off every copy of this stream\'s key, including your own link in your software. ' +
  'Re-paste the new link anywhere you use it.'

export const rotateStreamKey = async (eventId: string, token: string): Promise<void> => {
  await graphqlRequest<{ rotation: { eventId: string, overlayTokenVersion: number } }>(
    rotateOverlayTokensMutation, { eventId }, token
  )
}

type ResetListener = () => void

const listeners = new Map<string, Set<ResetListener>>()

export const announceStreamKeyReset = (eventId: string): void => {
  const set = listeners.get(eventId)
  if (set == null) return
  Array.from(set).forEach((cb) => cb())
}

export const onStreamKeyReset = (eventId: string, cb: ResetListener): (() => void) => {
  if (eventId === '') return () => {}
  let set = listeners.get(eventId)
  if (set == null) {
    set = new Set()
    listeners.set(eventId, set)
  }
  const held = set
  held.add(cb)
  return () => {
    held.delete(cb)
    if (held.size === 0 && listeners.get(eventId) === held) listeners.delete(eventId)
  }
}
